webpackJsonp([35783957827783],{

/***/ 1405:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/af-iverted-logo.7ac84315.svg";

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/indy-avatar.744227a0.svg";

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hero = function Hero(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "hero " + (props.className ? props.className : "") },
	    _react2.default.createElement(
	      "div",
	      { className: "hero__content" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        props.children
	      )
	    )
	  );
	};
	
	Hero.propTypes = {
	  className: _propTypes2.default.string
	};
	
	Hero.defaultProps = {
	  className: undefined
	};
	
	exports.default = Hero;
	module.exports = exports["default"];

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Content = __webpack_require__(9);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Hero = __webpack_require__(113);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _afIvertedLogo = __webpack_require__(1405);
	
	var _afIvertedLogo2 = _interopRequireDefault(_afIvertedLogo);
	
	var _indyAvatar = __webpack_require__(202);
	
	var _indyAvatar2 = _interopRequireDefault(_indyAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var index = function index(_ref) {
	  var transition = _ref.transition;
	  return _react2.default.createElement(
	    'div',
	    { style: transition && transition.style },
	    _react2.default.createElement(
	      _Content2.default,
	      { header: true },
	      _react2.default.createElement(
	        _Hero2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'hero' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'hero__heading' },
	            'Jakten p\xE5 den oslipade diamanten'
	          ),
	          _react2.default.createElement(
	            'h2',
	            { className: 'hero__heading' },
	            '\u201CFantastiskt, enkelt och l\xE4ttf\xF6rst\xE5eligt, en tankev\xE4ckare\u201D'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'hero__subheading' },
	            'Anonym anv\xE4ndare november 2018'
	          ),
	          _react2.default.createElement(
	            'h2',
	            { className: 'hero__heading' },
	            '\u201CBra koncept och det blir roligare n\xE4r man ska skriva annonser\u201D'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'hero__subheading' },
	            'Anonym anv\xE4ndare juli 2018'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Tusentals anv\xE4ndare \xF6vade p\xE5 att uppt\xE4cka arbetsmarknadens vanligaste floskler mellan juni och december 2018.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Nu tar vi konceptet vidare och utvecklar ett verktyg f\xF6r att prioritera vilka mjuka kompetenser som \xE4r viktigast n\xE4r man rekryterar.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Vill du delta i utvecklingsarbetet?',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'a',
	              {
	                className: 'hero__contact-link',
	                href: 'mailto:team-sokkandidater@arbetsformedlingen.se',
	                target: '_top'
	              },
	              'H\xF6r av dig till oss!'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'logo-bar' },
	        _react2.default.createElement('img', { src: _afIvertedLogo2.default, alt: 'Arbetsförmedlingen' })
	      )
	    )
	  );
	};
	
	exports.default = index;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-e9887e5c6a0da24a82a7.js